import type { SpaceRole } from '@/types/spaces';

/** Privilege rank — mirrors the backend's `SPACE_ROLE_RANK` so client-side
 *  gating decisions match server-side enforcement. */
export const SPACE_ROLE_RANK: Record<SpaceRole, number> = {
  viewer: 0,
  member: 1,
  admin: 2,
  owner: 3,
};

/** Check whether the caller's actual role meets a minimum requirement.
 *  Returns `false` if `actual` is missing (e.g. caller isn't a member). */
export function meetsRole(actual: SpaceRole | undefined, required: SpaceRole): boolean {
  if (!actual) return false;
  return SPACE_ROLE_RANK[actual] >= SPACE_ROLE_RANK[required];
}
